// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VehicleConstants$PorterinUtils from "../constants/VehicleConstants.mjs";

function toString(vehicle_type) {
  switch (vehicle_type) {
    case /* TwoWheelers */0 :
        return VehicleConstants$PorterinUtils.twoWheelerString;
    case /* Canter3Tonne */1 :
        return VehicleConstants$PorterinUtils.canter3Tonne;
    case /* Pickup1Tonne */2 :
        return VehicleConstants$PorterinUtils.pickup1Tonne;
    case /* OneTon7Feet */3 :
        return VehicleConstants$PorterinUtils.oneTon7Feet;
    case /* Compact */5 :
        return VehicleConstants$PorterinUtils.compact;
    case /* Courier */6 :
        return VehicleConstants$PorterinUtils.courier;
    case /* PackersMovers */7 :
        return VehicleConstants$PorterinUtils.packersMovers;
    case /* Trucks */4 :
    case /* Partload */8 :
        return VehicleConstants$PorterinUtils.trucks;
    
  }
}

function fromString(vehicleType) {
  if (vehicleType === VehicleConstants$PorterinUtils.twoWheelerNumeric || vehicleType === VehicleConstants$PorterinUtils.twoWheelerString || vehicleType === VehicleConstants$PorterinUtils.twoWheelerSnakeCase || vehicleType === VehicleConstants$PorterinUtils.twoWheelerKebabCase || vehicleType === VehicleConstants$PorterinUtils.twoWheelerSingularKebabCase || vehicleType === VehicleConstants$PorterinUtils.twoWheelerAlternative || vehicleType === VehicleConstants$PorterinUtils.motorcycle) {
    return /* TwoWheelers */0;
  } else if (vehicleType === VehicleConstants$PorterinUtils.canter3Tonne || vehicleType === VehicleConstants$PorterinUtils.pickup1Tonne || vehicleType === VehicleConstants$PorterinUtils.oneTon7Feet || vehicleType === VehicleConstants$PorterinUtils.compact || vehicleType === VehicleConstants$PorterinUtils.trucks || vehicleType === VehicleConstants$PorterinUtils.truckSingular || vehicleType === VehicleConstants$PorterinUtils.pickup1_5Tonne || vehicleType === VehicleConstants$PorterinUtils.minivan || vehicleType === VehicleConstants$PorterinUtils.pickup1_Ton) {
    return /* Trucks */4;
  } else if (vehicleType === VehicleConstants$PorterinUtils.courier) {
    return /* Courier */6;
  } else if (vehicleType === VehicleConstants$PorterinUtils.packersMovers) {
    return /* PackersMovers */7;
  } else {
    return /* Trucks */4;
  }
}

function getOptionalTypeFromString(vehicleType) {
  if (vehicleType === VehicleConstants$PorterinUtils.twoWheelerNumeric || vehicleType === VehicleConstants$PorterinUtils.twoWheelerString || vehicleType === VehicleConstants$PorterinUtils.twoWheelerSnakeCase || vehicleType === VehicleConstants$PorterinUtils.twoWheelerAlternative) {
    return /* TwoWheelers */0;
  } else if (vehicleType === VehicleConstants$PorterinUtils.trucks) {
    return /* Trucks */4;
  } else if (vehicleType === VehicleConstants$PorterinUtils.compact) {
    return /* Compact */5;
  } else if (vehicleType === VehicleConstants$PorterinUtils.courier) {
    return /* Courier */6;
  } else if (vehicleType === VehicleConstants$PorterinUtils.truckSingular) {
    return /* Trucks */4;
  } else if (vehicleType === VehicleConstants$PorterinUtils.packersMovers) {
    return /* PackersMovers */7;
  } else {
    return ;
  }
}

function mapVehicleNameToCategoryString(name) {
  var match = name.toLowerCase();
  switch (match) {
    case "1 ton 7 feet" :
    case "1 টন 7 ফিট" :
        return VehicleConstants$PorterinUtils.oneTon7Feet;
    case "compact-dubai" :
    case "compact-sharjah" :
        return VehicleConstants$PorterinUtils.compact;
    case "hafif ticari" :
    case "minivan" :
        return VehicleConstants$PorterinUtils.minivan;
    case "pickup 1ton" :
        return VehicleConstants$PorterinUtils.pickup1_Ton;
    case "2 wheeler" :
    case "motorcycle" :
    case "motosiklet" :
    case "two wheeler" :
    case "মোটরসাইকেল" :
        return VehicleConstants$PorterinUtils.twoWheelerNumeric;
    case "cng" :
    case "সিএনজি" :
        return VehicleConstants$PorterinUtils.cng;
    default:
      return name;
  }
}

export {
  toString ,
  fromString ,
  getOptionalTypeFromString ,
  mapVehicleNameToCategoryString ,
}
/* No side effect */
